import { bundledScoreById } from './bundledScores';
import { useStore } from '@/state/store';
import type { PlaylistTuneRef } from '@/storage/playlists';
import { canEditPlaylist } from '@/storage/playlistLinks';

/** An offered replacement, never an implicit change to a pinned revision. */
export function latestPlaylistScoreRef(
  ref: PlaylistTuneRef,
): Extract<PlaylistTuneRef, { kind: 'score' }> | undefined {
  if (ref.kind !== 'score') return;
  const entry = bundledScoreById(ref.id);
  if (
    !entry ||
    entry.listing.status !== 'active' ||
    !entry.previousRevisionIds?.includes(ref.revisionId)
  )
    return;
  return {
    kind: 'score',
    id: entry.record.id,
    revisionId: entry.revision.id,
    title: entry.summary.title,
    composer: entry.summary.composer,
  };
}

/** Re-read the row at click time: another editor may have changed it since
 * the offer was rendered. Notes, calls and row identity belong to the playlist. */
export function updatePlaylistScore(playlistId: string, entryId: string): boolean {
  const state = useStore.getState();
  if (!canEditPlaylist(state.playlistLinks, playlistId)) return false;
  const entry = state.userPlaylists
    .find((p) => p.id === playlistId)
    ?.entries.find((e) => e.entryId === entryId);
  const replacement = entry && latestPlaylistScoreRef(entry.ref);
  if (!replacement) return false;
  state.replacePlaylistEntryRef(playlistId, entryId, replacement);
  return true;
}
